import {fetchApi} from "../fetch";
import {API_URL} from "../../constants/axios";


export const getProfileList = async () => {
    const res = await fetchApi.get(API_URL.WIZARD_PROFILE_LIST)
    return res.data
}
export const getAccountList = async () => {
    const res = await fetchApi.get(API_URL.WIZARD_ACCOUNT_LIST)
    return res.data
}

export const getProfileInfo = async (bizNum) => {
    const res = await fetchApi.get(`${API_URL.WIZARD_PROFILE_INFO}?bizNum=${bizNum}`)
    return res.data
}

// bizRegNumber 추가(2026-08-21) — 관리자 위저드 STEP 2 입력값을 채널에 남긴다.
// 서버는 정규화 후 **비어 있을 때만** 채운다(기존 값은 덮어쓰지 않는다).
/**
 * 사업자번호로 **이미 접수된 미완료 연동 신청**을 찾는다(2026-09-01 신규).
 *
 * 결과가 있으면 STEP 3 에서 '이 신청에 이어서 세팅' 을 제안한다.
 * 없으면 `data` 가 null 이다(= 신규 업체이거나 고객이 사업자번호를 다르게 입력했다).
 */
export const getPendingChannel = async (bizNum) => {
    const res = await fetchApi.get(`${API_URL.WIZARD_CHANNEL_PENDING}?bizNum=${encodeURIComponent(bizNum)}`)
    return res.data
}

/**
 * @param adoptChannelId 이어받을 미완료 채널 id. **null 이면 새 채널을 만든다.**
 * @param hostingName    연동 방식 정정값. null 이면 고객이 고른 값을 보존한다(서버가 부분 갱신).
 */
export const saveChannel = async (id, name, searchId, publicId, profileKey, accountId, bizRegNumber,
                                  adoptChannelId = null, hostingName = null) => {
    const res = await fetchApi.post(`${API_URL.WIZARD_CHANNEL_SAVE}`, {
        id, name, searchId, publicId, profileKey, accountId, bizRegNumber, adoptChannelId, hostingName
    })
    return res.data
}
export const setupChannel = async (channelId, restApiKey, javascriptKey) => {
    const res = await fetchApi.post(`${API_URL.WIZARD_CHANNEL_SETUP}`, {
        channelId, restApiKey, javascriptKey
    })
    return res.data
}

export const completed = async (channelId) => {
    const res = await fetchApi.post(`${API_URL.WIZARD_CHANNEL_COMPLETED}`, {
        channelId
    })
    return res.data
}

/**
 * STEP 4 직후 채널의 연동 방식을 읽는다(2026-10-30).
 *
 * 응답 `data` = `{channelId, hostingName, isExternalMall, omoplaySiteId}` 또는 채널이 없으면 null.
 * STEP 5 '홈페이지 생성' 은 **오모플레이 제공 자사몰 고객용**이라, 카페24 등 외부 몰로 신청한
 * 채널(`isExternalMall`)에는 건너뛸 수 있게 보여준다. 판정 근거는 서버의 `account_channel.hosting_name`
 * 하나다 — 프론트가 신청서(`pendingChannel`)로 따로 유추하지 않는다.
 */
export const getWizardChannelInfo = async (channelId) => {
    const res = await fetchApi.get(`${API_URL.WIZARD_CHANNEL_INFO}?channelId=${encodeURIComponent(channelId)}`)
    return res.data
}
